import React, { useState } from "react";
import logo from "../asset/logo.png";
import appleLogo from "../asset/appleLogo.png";
import playstoreLogo from "../asset/playstoreLogo.png";
import facebook from "../asset/square-facebook.svg";
import instagram from "../asset/instagram.svg";
import youtube from "../asset/youtube.svg";
import "../navbar.css";
import { useNavigate } from "react-router-dom";

function Footer() {
    const navigate = useNavigate();

    const goToHome = (route) => {
        navigate("/" + route);
    };
    return (
            <div className="footer">
                <div className="footersection">
                    <div className="footerlinks">
                        <div className="footerlinks-1">
                            <h2>COMPANY</h2>

                            <a href="">
                                PRIVACY POLICY
                            </a>

                            <a href="">
                                TERMS OF SALES
                            </a>

                            <a href="">
                                COOKIE POLICY
                            </a>

                            <a href="">
                                NOTICE AT COLLECTION
                            </a>
                            <a href="">DO NOT SELL OR SHARE MY PERSONAL INFORMATION</a>

                            <a href="">
                                SUPPLY CHAIN ACT
                            </a>
                            <a href="">
                                TERMS & CONDITIONS
                            </a>
                        </div>

                        <div className="footerlinks-1">
                            <h2>QUICK LINKS</h2>

                            <a onClick={() => goToHome("home")}>
                                HOME
                            </a>

                            <a onClick={() => goToHome("registerpage")}>
                                REGISTER
                            </a>
                        </div>

                        <div className="footerlinks-1">
                            <h2>INFORMATION</h2>

                            <a href="https://petivitybrands.myshopify.com/pages/contact">
                                CONTACT
                            </a>

                            <a href="https://petivitybrands.myshopify.com/pages/how-it-works">
                                HOW IT WORKS
                            </a>
                        </div>
                    </div>
                </div>              
            </div>
    );
}
export default Footer;
